import { render, staticRenderFns } from "./PrevValuesDictionaryList.vue?vue&type=template&id=50efbc0b&scoped=true"
import script from "./PrevValuesDictionaryList.vue?vue&type=script&lang=js"
export * from "./PrevValuesDictionaryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50efbc0b",
  null
  
)

export default component.exports